import { IoMdMore } from "react-icons/io";
import { LuUser } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";

import { isButtonElement } from "react-router-dom/dist/dom";
import { useStateSetter } from "../../../../hooks/statehooks/UseStateSettersHook";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit, CiNoWaitingSign } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { Fragment } from "react/jsx-runtime";
import { useState } from "react";
import EditLeaveTypeModal from "../../../../components/Modules/Employees/EditLeaveTypeModal";
import useLeaveHook from "../../../../hooks/useLeaveHook";
import { onDeleteLeaveType } from "../../../../services/leave";
import { useStateGetter } from "../../../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";

export default ({ item, refresh }: any) => {
  const navigate = useNavigate();
  const { setSelecteduser, setLoading } = useStateSetter();
  const [setshowedittype, setsetshowedittype] = useState(false);
  const { setSidebarRenderView } = useStateSetter();
   const { config } = useStateGetter();

  const Delete = async () => {
    try {
      setLoading(true);
      var res = await onDeleteLeaveType(item.id, config);
      if (res.success) {
        toast.success(res.message);
      await refresh()
      }
    } catch (e: any) {
      console.log(e);
      toast.error(e);
    } finally {
      setLoading(false);

    }
  };

  return (
    <div
      onClick={() => {
        // setSidebarRenderView(<EmployeeDetailed  id={item.id} />)
      }}
      className="bg-whit shadow-sm border border-gray-200 rounded-[10px] my-2 flex  py-4  px-1 justify-between items-center"
    >
      {setshowedittype && (
        <EditLeaveTypeModal
          item={item}
          refresh={refresh}
          show={setsetshowedittype}
        />
      )}
      <div className="flex">
        <div className=" px-2">
          <p className="font-semibold text-md cursor-pointer">
            {item.leaveName}
          </p>
          <p className="font-light text-xs cursor-pointer">
            {" "}
            {item.description}{" "}
          </p>
          <p className="font-light text-xs cursor-pointer inline">
            <GoDotFill className="inline text-green-600" /> {"active"}
          </p>
          <div></div>
        </div>
      </div>

      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <div className="flex flex-items items-center  w-full gap-4">
            <div className=" flex justify-between w-full  items-center p-1">
              <IoMdMore size={20} className="text-textbg " />
            </div>

            <div className="flex items-center"></div>
          </div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-left z-10 absolute   mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none">
            <Menu.Item>
              <p
                onClick={() => {
                  setsetshowedittype(true);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <CiEdit className="inline" /> Edit
              </p>
            </Menu.Item>

            <Menu.Item>
              <p
             onClick={async ()=> Delete()}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <MdDelete  className="inline" /> Delete
              </p>
            </Menu.Item>
            <Menu.Item>
              <p
                onClick={() => {}}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <CiNoWaitingSign className="inline" /> Deactivate
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
